'use strict';

(function () {

  angular
    .module('specsguardApp')
    .controller('sgUserIconCtrl', sgUserIconCtrl);

  sgUserIconCtrl.$inject = ['$scope'];

  function sgUserIconCtrl ($scope) {

    const vm = this;

    function setUser ( user: User ) {
      vm.user = user;
      vm.gravatarUrl = 'https://www.gravatar.com/avatar/' + vm.user.gravatarHash + '?d=blank';
      vm.initials = (vm.user.nameFirst[0] + vm.user.nameLast[0]).toUpperCase();
      vm.bgColorClass = $scope.overrideColor ? $scope.overrideColor : 'sg-bgcolor-' + parseInt(vm.user._id, 0) % 20;

      if (!vm.user || !vm.user.nameFirst) {
        vm.initials = '?';
        vm.bgColorClass = 'sg-bgcolor-0';
        return;
      }
    }

    setUser($scope.user);

    // sgUserIcon directive needs to watch any changes on the properties.
    $scope.$watch('user', function (newVal, oldVal) {
      if ( newVal !== oldVal) {
        setUser(newVal);
      }
    });

  }
})();
